export class BaseXAtlas {
}
